const Agents = [
    {
      name: "Arun",
      title: "Agent",
      id: "XB6J98",
      code: "XB6J98",
      pincode: "678612",
      location: "Parli",
      district: "Palakkad",
      state: "Kerala",
      discount: 15
    }
  ];
export default Agents;